import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=dcdd6476&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=ts&"
export * from "./checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=dcdd6476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdd6476",
  null
  
)

export default component.exports